import {DatePipe} from "@angular/common";

export class DateTime {
    public static formatDateForDisplay(date: Date, includeYear: boolean = true): string {
        return date ? new DatePipe("en-US").transform(date, includeYear ? "EEE MMM d, yyyy" : "EEE MMM d") : null;
    }

    public static formatTimeForDisplay(date: Date): string {
        // We need to use en-US for 12-hour times due to chrome's time formatting quirks.
        return date ? new DatePipe("en-US").transform(date, "h:mm a").toUpperCase() : null;
    }

    public static formatDateTimeForDisplay(date: Date): string {
        return date ? (DateTime.formatDateForDisplay(date) + " " + DateTime.formatTimeForDisplay(date)) : null;
    }

    public static formatDateForEdit(date: Date): string {
        const y: number = date.getFullYear();
        const m: number = date.getMonth() + 1;
        const d: number = date.getDate();
        return y + "-" + (m < 10 ? "0" : "") + m + "-" + (d < 10 ? "0" : "") + d;
    }
}



// WEBPACK FOOTER //
// ./src/app/string-utils/date-time.ts